<template>
  <div class="flex-1-1 p-x-1:mo BACKGROUND  ">
    <div class="MESSAGES " :key="messageKey">
      <div v-if="$device.isMobile && !hasSelectedMessage || !$device.isMobile" class="LIST SIDEBAR">
        <message-list @clickOnMessage="clickOnMessage" @updateHasMessages="updateHasMessages"/>
      </div>
      <div v-if="$device.isMobile && (hasSelectedMessage || !hasMessages) || !$device.isMobile" class="BODY">
        <div v-if="hasSelectedMessage" class="MESSAGE">
          <pro-messages @message-sent="messageSent"/>
        </div>
        <div v-else class="INFO">
          <div v-if="hasMessages" class="INFORMATION">
            <img src="./assets/EmptyMessages.svg" alt="" class="IMG">
            <span class="c-gray90">Select a message</span>
            <span class="p-b-3 text-center c-gray60 TEXT-REGULAR">
              Choose from your existing conversations and reach out to your customers.
            </span>
          </div>
          <div v-else class="INFORMATION">
            <img src="./assets/EmptyInbox.svg" alt="" class="IMG">
            <span>You have no messages</span>
            <span class="p-b-3 TEXT-REGULAR" >Go to Jobs and reach out to your customers</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DashboardSection from '@/views/Dashboard/components/DashboardSection';
import job from '@/mixins/job';
import jobParams from '@/mixins/job-params';
import workOrder from '@/mixins/work-order';
import { mapActions } from 'vuex';
import ProMessages from './components/ProMessages/ProMessages';
import MessageList from './components/MessageList';

export default {

  name: 'dashboard-messages',
  components: {
    DashboardSection,
    ProMessages,
    MessageList,
  },
  mixins: [
    jobParams,
    job,
    workOrder,
  ],
  data () {
    return {
      messageKey: 0,
      hasMessages: false,
    };
  },
  computed: {
    hasSelectedMessage () {
      return !!this.jobId;
    },
  },
  mounted () {
    this.clearInbox();
  },
  methods: {
    ...mapActions('account/pro/inbox', ['clearInbox']),
    updateHasMessages  (val) {
      this.hasMessages = val;
    },
    messageSent () {
      this.clearInbox();
      this.messageKey += 1;
    },
    clickOnMessage (jobId) {
      this.$router.push({
        name: 'dashboard::pro::messages',
        params: {
          jobId,
        } });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  .MESSAGES {
    background-color: white;
    width: 100%;
    height: 80vh;
    margin-top: 5 * $unit;
    display: flex;
    @include mobile-only() {
      // border-bottom: solid 1px $color-gray40;
      height: 75vh;
      margin-top: unset;
    }

    h2 {
      margin: 0;
    }
  }
  .BACKGROUND {
    @include mobile-only(){
      background-color: white;
    }
  }
  .LIST {
    width: 30%;
    border-right: 1px solid $color-gray30;
    @include mobile-only() {
      width: 100%;
      border-right: none;
    }
  }
  .BODY {
    width: 70%;
    @include mobile-only() {
      width: 100%;
    }
  }
  .INFO {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

  }
  .IMG {
    margin: 2*$unit $unit $unit $unit;
    width: 118px;
  }
  .TOKEN {
    @include square(40px);
  }
  .INFORMATION {
    display: flex;
    flex-direction: column;
    align-items: center;
    width:320px;
    background-color: $color-gray10;
    box-shadow:0px 10px 10px 0px  $color-gray30 ;
  }
  .TEXT-REGULAR{
    font-size: 14px;
  }
  .SIDEBAR {
    @include responsive(width, 100%, 320px, 428px);
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    border-left: 1px solid $color-gray30;
    border-right: 1px solid $color-gray30;
    background-color: white;
  }
</style>
